import { useState, useMemo } from "react";
import {JiraWorklogsWrapper, DataWrapper} from "./styled"
import { DateSelectorPerMonth } from "./DateSelectorPerMonth"
import { Error } from "../../../common/Error";
import { Loading } from "../../../common/Loading";
import { getTotalNonServiceTime, formatDate } from "../../../utils/timeCalculations";
import { JiraWorklogsList } from "./JiraWorklogsList";
import { useJiraData } from "../../../utils/useJiraData";
import { SummaryWorkLogs } from "./SummaryWorkLogs";

export const JiraWorklogs = () => {
  const [selectedMonth, setSelectedMonth] = useState(new Date().getMonth());
  const [selectedYear, setSelectedYear] = useState(new Date().getFullYear());
  const acceptedTasks= false;

  const { startDate, endDate } = useMemo(() => {
    const start = new Date(Date.UTC(selectedYear, selectedMonth, 1));
    const end = new Date(Date.UTC(selectedYear, selectedMonth + 1, 0));
    return { startDate: start, endDate: end };
  }, [selectedMonth, selectedYear]);

  const { loading, error, data } = useJiraData(acceptedTasks, startDate, endDate);

  const handleMonthChange = (newMonth) => {
    setSelectedMonth(newMonth);
  };

  const handleYearChange = (newYear) => {
    setSelectedYear(newYear);
  };

  if (loading) {
    return <Loading />;
  }

  if (error) {
    return <Error message={error} />;
  }

  const totalNonServiceTime = getTotalNonServiceTime(
    data,
    selectedMonth,
    selectedYear
  );

  return (
    <JiraWorklogsWrapper>
      <SummaryWorkLogs
        totalNonServiceTime={totalNonServiceTime}
        selectedMonth={selectedMonth}
        selectedYear={selectedYear}
        data={data}
      />

      <DataWrapper>
        <DateSelectorPerMonth
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
          setSelectedMonth={handleMonthChange}
          setSelectedYear={handleYearChange}
        />

        <JiraWorklogsList
          data={data}
          selectedMonth={selectedMonth}
          selectedYear={selectedYear}
        />
      </DataWrapper>
    </JiraWorklogsWrapper>
  );
};
